// export const formatDate = (dateString) => {
//   const date = new Date(dateString);
//   if (isNaN(date)) return dateString; // Return original string if not a valid date
  
//   // Extract day, month, and year components
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
//   const year = date.getFullYear();
  
//   return `${day}-${month}-${year}`;
// };

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString; // Return original string if not a valid date

  // Define month names
  const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = monthNames[date.getMonth()]; // Get month name in `MMM` format
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
};  